module.exports = __webpack_public_path__ + "media/88_Long.cd00619c.mp3";